<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M13.5 4H6V14.8333M9.33333 7.33333H17.6667V19H9.33333V7.33333Z" stroke="currentColor" stroke-width="1.5" />
  </svg>
</template>
